export default 'Частный';
